import * as Sentry from '@sentry/nextjs';
import { SENTRY_DATA_COLLECTION, SENTRY_DSN } from '@src/constants';

export const initializeSentryClient = (env_name: string): void => {
	// Prevent multiple initializations
	if (Sentry.isInitialized()) {
		return;
	}
	const isProd = env_name === 'production' || env_name === 'prod';
	Sentry.init({
		dsn: SENTRY_DSN,

		// Add optional integrations for additional features
		integrations: [Sentry.replayIntegration(), Sentry.browserProfilingIntegration()],

		// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
		tracesSampleRate: 0.05,

		// Share of user sessions that profile; each profiling session profiles its sampled traces
		profileSessionSampleRate: 0.05,
		profileLifecycle: 'trace',

		// Define how likely Replay events are sampled.
		// This sets the sample rate to be 5%. You may want this to be 100% while
		// in development and sample at a lower rate in production
		replaysSessionSampleRate: 0.05,

		// Define how likely Replay events are sampled when an error occurs.
		replaysOnErrorSampleRate: 0.05,

		// Setting this option to true will print useful information to the console while you're setting up Sentry.
		debug: !isProd,
		environment: env_name,
		dataCollection: SENTRY_DATA_COLLECTION,
	});
};
